exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-home[data-v-cc633e7a]{-webkit-box-sizing:border-box;box-sizing:border-box;width:100vw;height:100vh;position:relative;overflow:hidden}", ""]);

// exports
